export default __webpack_public_path__ + "static/media/Img2.3a9b6df6.jpg";